import { Network, Package, Stack } from "components/icons/generated";
import Badge from "ds/components/Badge";
import { BadgeVariants } from "ds/components/Badge/types";
import { IconComponent } from "types/Icon";

type ProjectTypeConfig = {
  variant: BadgeVariants;
  text: string;
  icon: IconComponent;
};

export enum ProjectType {
  Stack = "stack",
  Module = "module",
  Intent = "intent",
}

/** @public (Knip ignored - used in the file and exported for stories) */
export const PROJECT_TYPES: Record<ProjectType, ProjectTypeConfig> = {
  [ProjectType.Stack]: { variant: "blue", text: "Stack", icon: Stack },
  [ProjectType.Module]: { variant: "yellow", text: "Module", icon: Package },
  [ProjectType.Intent]: { variant: "green", text: "Intent", icon: Network },
};

type ProjectTypeBadgeProps = {
  projectType: ProjectType;
  className?: string;
};

const ProjectTypeBadge = ({ projectType, className }: ProjectTypeBadgeProps) => {
  return (
    <Badge
      variant={PROJECT_TYPES[projectType].variant}
      startIcon={PROJECT_TYPES[projectType].icon}
      className={className}
      text={PROJECT_TYPES[projectType].text}
      type="weak"
    />
  );
};

export default ProjectTypeBadge;
